<div class="py-[30px]">
  <ng-container *ngIf="!showBookingSettings; else bookingSettings">
    <div class="v4-layout-form">
      <div class="v4-layout-form-title">
        {{ "property-property_detail-pricing_html_基础周末价" | translate }}
        <!-- Base & Weekend Price -->
      </div>
      <div class="">
        <div class="flex flex-row items-center justify-between">
          <div class="w-[300px] mr-3 h-height-lg"></div>
          <div class="flex flex-row items-center">
            <div class="w-32 mr-6 h-height-lg">
              {{ "property-property_detail-pricing_html_基础价" | translate }}
              <!-- Base price -->
            </div>
            <div class="w-32 mr-6 h-height-lg">
              {{ "property-property_detail-pricing_html_周末价" | translate }}
              <!-- Weekend price -->
            </div>
          </div>
        </div>
        <div class="flex flex-row items-center justify-between">
          <div class="w-[300px] mr-3">
            {{ "property-property_detail-pricing_html_一键改价" | translate }}
            <!-- Quick Modify -->
          </div>
          <div class="flex flex-row items-center">
            <div class="w-32 mr-6">
              <input
                type="text"
                nz-input
                nzSize="large"
                [placeholder]="'property-property_detail-pricing_html_daily_price' | translate"
                [(ngModel)]="batchDailyPrice"
                (ngModelChange)="onBatchDailyPriceChange()" />
            </div>
            <div class="w-32 mr-6">
              <input
                type="text"
                nz-input
                nzSize="large"
                [placeholder]="'property-property_detail-pricing_html_weekend_price' | translate"
                [(ngModel)]="batchWeekendPrice"
                (ngModelChange)="onBatchWeekendPriceChange()" />
            </div>
          </div>
        </div>
        @for (item of prices?.slice(0, showMoreListings() ? prices.length : showMoreListingsLimit); track $index) {
          <div class="flex flex-row items-center justify-between mt-3">
            <div class="mr-[30px] flex flex-row items-center flex-1">
              <img class="w-[16px] mr-[8px]" [src]="(item.thirdparty_type | thirdparty)?.icon_color_bg" alt="" />
              <div class="ellipsis-line-2" [title]="item.title">{{ item.title }}</div>
            </div>

            <div class="flex flex-row items-center">
              @for (type of ["daily_price", "weekend_price"]; track $index) {
                <div class="w-32 mr-6">
                  @if (isSupportPrice($any(type), item.thirdparty_type)) {
                    <input
                      type="text"
                      nz-input
                      nzSize="large"
                      [placeholder]="'property-property_detail-pricing_html_' + type | translate"
                      [(ngModel)]="item[type]" />
                  } @else {
                    <input
                      type="text"
                      nz-input
                      nzSize="large"
                      [disabled]="true"
                      placeholder="N/A"
                      nz-tooltip
                      [nzTooltipTitle]="'property-property_detail-pricing_html_' + type + '_unsupport' | translate" />
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (prices?.length > showMoreListingsLimit) {
          <div class="mt-3 leading-[42px]">
            <a href="javascript:void(0)" (click)="showMoreListings.set(!showMoreListings())">{{
              showMoreListingsText()
            }}</a>
          </div>
        }
        <div class="mt-6">
          <button nz-button nzType="primary" nzSize="large" (click)="onSave()">
            {{ "word.save" | translate }}
            <!-- Save -->
          </button>
        </div>
      </div>
    </div>

    <div class="v4-layout-form">
      <div class="v4-layout-form-title">
        {{ "property-property_detail-pricing_html_房间设置" | translate }}
        <!-- Listing Specific Settings -->
      </div>
      <div class="">
        <!-- <nz-alert nzShowIcon nzMessage="Set up weekly discount, security deposit, check-in/out time, minimum stay, etc."></nz-alert>  -->

        <nz-table
          #nzTable
          class="v4-layout-list"
          [nzFrontPagination]="false"
          [nzData]="listOfHouseSupportSetRules"
          [nzTotal]="total"
          [(nzPageIndex)]="page"
          [nzPageSize]="pageSize"
          nzPaginationType="small"
          [nzShowTotal]="totalTpl"
          (nzPageIndexChange)="onPageChange()">
          <thead>
            <tr>
              <th>{{ "word.house_list" | translate }}</th>
            </tr>
          </thead>
          <tbody class="v4-layout-list-body">
            <tr class="cursor-pointer" (click)="onClickHouse(house)" *ngFor="let house of nzTable.data">
              <td>
                <div class="flex flex-row items-center">
                  <div class="relative mr-2">
                    <img
                      class="absolute left-1 top-1 w-[18px] h-[18px] rounded-full"
                      [src]="(house.thirdparty_type | thirdparty)?.icon_color_bg"
                      alt="" />
                    <span class="absolute right-1 top-1 count">{{ house.inventory }}</span>
                    <img
                      class="w-20 h-14 rounded-[10px]"
                      src="/assets/status/placeholder.png"
                      hostPlaceholder
                      [delaySrc]="house?.cover?.small_url"
                      alt="" />
                  </div>
                  <div>{{ house.title }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <ng-template #totalTpl>
          {{ "component-page_html_总数" | translate: { number: total } }}
          <!-- {{ total }} items -->
        </ng-template>
      </div>
    </div>
  </ng-container>

  <ng-template #bookingSettings>
    <div class="flex flex-row items-center mb-12">
      <i nz-icon nzType="left" nzTheme="outline" class="mr-2 cursor-pointer" (click)="showBookingSettings = false"></i>
      <nz-select class="w-[200px]" [(ngModel)]="currentHouse" [nzCustomTemplate]="selectTpl">
        <nz-option
          *ngFor="let house of listOfHouseSupportSetRules"
          [nzValue]="house"
          [nzLabel]="house.title"></nz-option>
      </nz-select>
      <ng-template #selectTpl let-selected>
        <div class="flex flex-row items-center">
          <img
            [src]="(selected.nzValue?.thirdparty_type | thirdparty)?.icon_color"
            alt=""
            class="w-[18px] h-[18px] rounded-full mr-2" />
          <span>{{ selected.nzLabel }}</span>
        </div>
      </ng-template>
    </div>
    <property-detail-booking-settings [house]="currentHouse"></property-detail-booking-settings>
  </ng-template>
</div>
